import React, { useEffect, useRef, useState } from 'react'
import { InputDiv, Label, Input, SearchOptions, Option } from '../../../../styles/select-style'
import axios from 'axios'
import { X } from 'lucide-react'

interface CompanyItemType {
  id: number
  companyName: string
  cnpj: string
}

interface PropsType {
  suppliers: CompanyItemType[]
  setSuppliers: React.Dispatch<React.SetStateAction<CompanyItemType[]>>
}

const SelectSupplierInResource:React.FC<PropsType> = ({suppliers, setSuppliers}) => {
  const [ items, setItems ] = useState<CompanyItemType[]>([])
  const [ inputItem, setInputItem ] = useState<string>('')
  const [ showOptions, setShowOptions ] = useState<boolean>(false)
  const inputRef = useRef<HTMLInputElement>(null)
  const optionsRef = useRef<HTMLUListElement>(null)
  const [ selectedIndex, setSelectedIndex ] = useState(0)
  
  useEffect(() => {
    setInputItem('')
  }, [])
  
  useEffect(() => {
    setSelectedIndex(0)
    axios.get(`${process.env.REACT_APP_CERTIFICATES_BASE_URL}/certificate/utils/companies`, {
      params: {
        query: inputItem,
        companyType: 2
      }
    })
      .then(response => {
        if(response.data) setItems(response.data)
      })
      .catch(error => {
        console.log(error)
      })
  }, [inputItem])
  
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      const target = event.target as Node
      if (
        optionsRef.current &&
        inputRef.current &&
        !optionsRef.current.contains(target) &&
        !inputRef.current.contains(target)
      ) {
        setShowOptions(false)
      }
    }
    document.addEventListener('mousedown', handleClickOutside)
    return () => {
      document.removeEventListener('mousedown', handleClickOutside)
    }
  }, [])

  const handleChangeInput = (e: React.ChangeEvent<HTMLInputElement>) => {
    setInputItem(e.target.value)
  }

  const handleSelectItem = (item: CompanyItemType) => {
    setInputItem('')
    setShowOptions(false)
    setSuppliers(prev => suppliers.some(s => s.id === item.id) ? prev : [...prev, item])
  }
  
  const handleSetOptionByKey = (e:React.KeyboardEvent) => {
    if(e.key === 'ArrowDown' && selectedIndex < items.length - 1) setSelectedIndex(prev => prev + 1)
    if(e.key === 'ArrowUp' && selectedIndex > 0) setSelectedIndex(prev => prev - 1)
    if(e.key === 'Enter') handleSelectItem(items[selectedIndex])
    if(e.key === 'Tab') setShowOptions(false)
  }

  const handleRemoveSupplier = (id: number) => {
    setSuppliers(prev => prev.filter(s => s.id !== id))
  }

  return(
    <InputDiv>
      <Label>Fornecedor</Label>
      <Input 
        ref={inputRef}
        type='text' 
        placeholder='Selecione'
        value={inputItem}
        onFocus={() => setShowOptions(true)}
        onChange={handleChangeInput}
        onKeyDown={(e) => handleSetOptionByKey(e)}
      />
      {showOptions && 
        <SearchOptions ref={optionsRef}>
          {items.map((s, index) => 
            <Option 
              key={index}
              onClick={() => handleSelectItem(s)}
              isSelected={index === selectedIndex}
            >
              {s.companyName}
            </Option>
          )}
        </SearchOptions>
      }
      <div style={{ display: 'flex', gap: '10px', flexWrap: 'wrap', marginTop: '10px' }}>
        {suppliers.map((supplier) => (
          <div
            key={supplier.id} 
            style={{ backgroundColor: '#fff',
            padding: '5px 10px', 
            borderRadius: '1rem', 
            fontSize: '14px', 
            fontWeight: '400', 
            color: '#696969', 
            border: '1px solid #C4C4C4',
            display: 'flex',
            alignItems: 'center',
            gap: '10px'
            }}>
            {supplier.companyName}
            <X size={16} style={{ cursor: 'pointer' }} onClick={() => handleRemoveSupplier(supplier.id)} />
          </div>
        ))}
      </div>
    </InputDiv>
  )
}

export default SelectSupplierInResource
